/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/voicemail-1214649': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M18 8a4 4 0 00-4 4 3.91 3.91 0 00.56 2H9.44a3.91 3.91 0 00.56-2 4 4 0 10-4 4h12a4 4 0 000-8zM6 14a2 2 0 112-2 2 2 0 01-2 2zm12 0a2 2 0 112-2 2 2 0 01-2 2z"/>'
  }
})
